<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>
      <span v-text="pu_form.instanceId + ' - '" />
      <span
        v-text="
          edit
            ? $t('pharmaops.title_mt_update')
            : $t('pharmaops.title_mt_create_add')
        "
      />
    </template>
    <div class="my-2">
      <b-tabs
        content-class="mt-3"
        active-nav-item-class="font-weight-bold"
        v-model="currentTab"
      >
        <b-tab title="Form" active>
          <b-form
            class="p-2"
            @submit.prevent="onSubmit"
            :method="'POST'"
            :action="route"
          >
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="_method" :value="method" />

            <div
              class="row"
              v-if="existing_mtemplates && existing_mtemplates.length"
            >
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-role"
                  label-for="message-templates"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('pharmaops.select_mt')" />
                    <a
                      href="#"
                      v-b-tooltip.hover
                      :title="$t('pharmaops.select_message_tooltip')"
                      type="primary"
                      class="fa fa-question-circle text-decoration-none"
                    >
                    </a>
                  </template>

                  <div class="row">
                    <div class="col-10">
                      <vue-multiselect
                        v-model="existing_message_template"
                        :options="existing_mtemplates"
                        :placeholder="$t('pharmaops.message_template')"
                        track-by="id"
                        label="name"
                        :allow-empty="false"
                        :selectLabel="''"
                        :deselectLabel="''"
                        :selectedLabel="''"
                        style="line-height: 1.4"
                        @input="onSelect"
                      ></vue-multiselect>
                    </div>
                    <div class="col-2">
                      <b-button
                        class="btn btn-secondary"
                        v-text="$t('buttons.unselect')"
                        @click="onClear"
                        :disabled="disableForm || !existing_message_template"
                      ></b-button>
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div v-if="!approval_process || pu_form.name != null" class="row">
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-name"
                  label-for="name"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('pharmaops.name')" />
                  </template>
                  <b-form-input
                    id="name"
                    name="name"
                    v-model.trim="pu_form.name"
                    :placeholder="$t('pharmaops.enter_name')"
                    :disabled="
                      disableForm || !!existing_message_template || edit
                    "
                  />
                  <div v-if="hasError('name')">
                    <div
                      class="alert alert-danger mt-1"
                      v-if="states.showPopUpErrors"
                      v-text="$t('commons.required_field_error')"
                    ></div>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div
              v-if="!approval_process || pu_form.description != null"
              class="row"
            >
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-description"
                  label-for="description"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('pharmaops.description')" />
                  </template>
                  <b-form-textarea
                    id="description"
                    name="description"
                    v-model.trim="pu_form.description"
                    :placeholder="$t('pharmaops.enter_description')"
                    :disabled="disableForm || !!existing_message_template"
                  />
                  <div v-if="hasError('description')">
                    <div
                      class="alert alert-danger mt-1"
                      v-if="states.showPopUpErrors"
                      v-text="$t('commons.required_field_error')"
                    ></div>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div v-if="showGCMA" class="row">
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-enter-gcma"
                  label-for="gcma"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('messages.gcma')" />
                  </template>
                  <b-form-input
                    id="gcma"
                    name="gcma"
                    v-model.trim="pu_form.gcma"
                    :placeholder="$t('messages.enter_gcma')"
                    :disabled="
                      disableForm ||
                      !!existing_message_template ||
                      (pu_form.id == null && edit) ||
                      edit
                    "
                  />
                </b-form-group>
              </div>
            </div>

            <div
              v-if="!approval_process || pu_form.message != null"
              class="row"
            >
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-message-template"
                  label-for="message_template"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('pharmaops.message_template_text')" />
                  </template>
                  <b-form-textarea
                    id="textarea"
                    v-model="pu_form.message"
                    :disabled="!!existing_message_template"
                    :placeholder="$t('pharmaops.enter_mt_text')"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                  <div v-if="hasError('message')">
                    <div
                      class="alert alert-danger mt-1"
                      v-if="states.showPopUpErrors"
                      v-text="$t('commons.required_field_error')"
                    ></div>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div v-if="!approval_process || pu_form.name != null" class="row">
              <div class="col-lg-12">
                <b-form-group
                  id="fieldset-active"
                  label-for="active"
                  label-size="lg"
                  label-class="font-weight-bold pb-0"
                >
                  <template slot="label">
                    <span v-text="$t('commons.active')" />
                  </template>

                  <toggle-button
                    v-model="pu_form.isActive"
                    :labels="{ checked: 'On', unchecked: 'Off' }"
                    :sync="true"
                    :disabled="!!existing_message_template"
                  />
                </b-form-group>
              </div>
            </div>

            <common-loading
              :message="$t('pharmaops.saving_message_template')"
              v-if="states.saving_pu_form"
            />
            <common-loading
              :message="$t('pharmaops.adding_message_template')"
              v-if="states.adding_pu_form"
            />
            <b-alert
              variant="danger"
              :show="states.showPopUpErrors && hasErrors()"
            >
              <em class="fa fa-times-circle mr-2"></em>
              {{ $t("commons.form_error") }}
            </b-alert>
            <b-alert
              variant="success"
              :show="states.showMessageTemplateSuccess"
            >
              <em class="fa fa-check-circle mr-2"></em>
              {{ $t("pharmaops.mt_saved_successfully") }}
            </b-alert>
            <b-alert
              variant="success"
              :show="states.showAddedMessageTemplateSuccess"
            >
              <em class="fa fa-check-circle mr-2"></em>
              {{ $t("pharmaops.mt_added_successfully") }}
            </b-alert>

            <b-alert variant="danger" :show="errorMessage != null">
              <em class="fa fa-times-circle mr-2"></em>
              <span v-html="errorMessage"></span>
            </b-alert>
          </b-form>
        </b-tab>
        <b-tab title="History" v-if="edit || existing_message_template" lazy>
          <b-card-text>
            <show-history
              :id="pu_form.id"
              :instance-id="pu_form.instanceId"
              :callback="MessagesApi.find"
            ></show-history>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer class="bg-white">
      <b-button
        type="submit"
        class="mr-2"
        variant="primary"
        v-text="save_or_update"
        @click="onSave"
        v-if="currentTab == 0"
        :disabled="disableForm"
      ></b-button>
      <b-button
        class="btn btn-danger"
        v-text="$t('buttons.close')"
        @click="onCancel"
        v-if="currentTab == 0"
        :disabled="disableForm"
      ></b-button>
    </template>
  </b-modal>
</template>
<script>
import MessagesApi from "../../../js/apis/MessagesApi";
import PharmaopsApi from "../../../js/apis/PharmaopsApi";
import { useManageAttributes } from "../../stores/manage-attributes";
export default {
  computed: {
    pu_form() {
      return this.useManageAttributes.pu_form;
    },
    states() {
      return this.useManageAttributes.states;
    },
    errors() {
      return this.useManageAttributes.errors;
    },
    errorMessage() {
      return this.useManageAttributes.errorMessage;
    },
    disableForm() {
      return this.useManageAttributes.disableForm;
    },
    disableCancel() {
      return this.useManageAttributes.disableCancel;
    },
    hasOriginalDataChanged() {
      return this.useManageAttributes.hasOriginalDataChanged;
    },
    showGCMA() {
      return (
        (!this.approval_process &&
          this.edit &&
          this.pu_form.gcma != null &&
          this.pu_form.gcma != "") ||
        (this.pu_form.gcma != null && this.pu_form.gcma != "") ||
        (!this.edit &&
          !this.approval_process &&
          !this.existing_message_template)
      );
    },
  },
  data() {
    return {
      csrf: null,
      route: null,
      method: "POST",
      save_or_update: this.$t("buttons.create"),
      approval_process: false,
      MessagesApi: MessagesApi,
      show: false,
      resolve: null,
      reject: null,
      edit: false,
      message_template: Object | Array,
      existing_message_template: null,
      existing_mtemplates: null,
      currentTab: 0,
      interaction: null,
      originalName: null,
      useManageAttributes: useManageAttributes(),
    };
  },
  watch: {
    "pu_form.name": function (newVal) {
      if (!this.edit) {
        this.pu_form.id = newVal && newVal.length ? this.createId(newVal) : "";
      }
    },
  },
  created() {
    this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
  },
  methods: {
    onSelect(e) {
      this.save_or_update = this.$t("buttons.add");
      this.pu_form.id = e.id;
      this.pu_form.name = e.name;
      this.pu_form.description = e.description;
      this.pu_form.isActive = e.isActive;
      this.pu_form.message = e.attributes.message;
      this.pu_form.gcma = e.attributes.gcma;
    },
    createId(name) {
      return String(name).replace(/\s+/g, "-").toLowerCase();
    },
    open(approval_process, message_template, interaction, existing_mtemplates) {
      this.approval_process = approval_process;
      this.useManageAttributes.setErrorMessage(null);
      this.interaction = interaction;
      this.existing_mtemplates = existing_mtemplates;
      this.useManageAttributes.updateStates({
        showSuccess: false,
        showPopUpErrors: false,
        showErrors: false,
        showMessageTemplateSuccess: false,
        showAddedMessageTemplateSuccess: false,
      });
      this.existing_message_template = null;

      if (message_template.hasOwnProperty("instanceId")) {
        this.edit = false;
        this.save_or_update = approval_process
          ? this.$t("buttons.add")
          : this.$t("buttons.create");
        this.method = "POST";
        this.initForm(message_template.instanceId);
      } else {
        this.edit = true;
        this.originalName = message_template.data.result.name;
        this.save_or_update = this.$t("buttons.update");
        this.method = "PATCH";
        this.useManageAttributes.setDocumentId(message_template.data.result.id);
        this.message_template = message_template;
        this.useManageAttributes.initializePopUp(message_template.data);
        this.useManageAttributes.updateMessageTemplatePopUpHeaders(
          message_template.headers
        );
      }
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    initForm(instanceId) {
      let formData = {
        result: {
          id: null,
          name: null,
          description: null,
          isActive: false,
          attributes: {
            message: null,
            gcma: null,
          },
          instanceId: instanceId,
        },
      };
      this.useManageAttributes.initializePopUp(formData);
    },
    hasErrors() {
      return (
        this.hasError("name") ||
        this.hasError("description") ||
        this.hasError("message")
      );
    },
    onSave() {
      this.pu_form.id = this.createId(this.pu_form.name);
      this.useManageAttributes.updateStates({
        showPopUpErrors: true,
      });

      if (this.hasErrors()) {
        this.$toast.error("Error", this.$t("commons.form_error"));
        return;
      }

      if (!this.existing_message_template) {
        this.useManageAttributes.updateStates({
          showMessageTemplateSuccess: false,
          removeSuccess: false,
          addedSuccess: false,
        });
      } else {
        this.useManageAttributes.updateStates({
          showMessageTemplateSuccess: false,
          removeSuccess: false,
          addedSuccess: false,
        });
      }
      this.useManageAttributes.setErrorMessage(null);

      let eTag = null;
      let headers = this.useManageAttributes.pu_mt_headers;
      if (headers && headers["ETag"] && headers["ETag"].length > 0) {
        eTag = headers["ETag"][0];
      }
      let payload = {
        result: {
          id: this.pu_form.id,
          name: this.pu_form.name,
          description: this.pu_form.description,
          isActive: this.pu_form.isActive,
          attributes: {
            message: this.pu_form.message,
            type: this.interaction == 0 ? "inbound" : "outbound",
            gcma: this.pu_form.gcma,
          },
          instanceId: this.pu_form.instanceId,
        },
        eTag: eTag,
      };
      this.useManageAttributes.initializePopUp(payload);

      if (this.edit) {
        this.updateMessageTemplate(payload);
      } else {
        this.saveMessageTemplate(payload);
      }
    },
    hasError(field) {
      if (!this.pu_form[field] || this.pu_form[field].length == 0) {
        this.useManageAttributes.updateErrors({ [field]: true });
        return true;
      } else {
        this.useManageAttributes.updateErrors({ [field]: false });
        return false;
      }
    },
    updateMessageTemplate(payload) {
      this.useManageAttributes.updateStates({
        saving_pu_form: true,
      });
      payload.payload = payload.result;
      delete payload.result;
      MessagesApi.update(payload, this.pu_form.instanceId, this.pu_form.id)
        .then((r) => {
          this.$toast.success(
            "Success",
            this.$t("pharmaops.mt_saved_successfully")
          );
          this.useManageAttributes.initializePopUp(r.data);
          this.useManageAttributes.updateMessageTemplatePopUpHeaders(r.headers);
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
            showMessageTemplateSuccess: true,
          });
          this.resolve(false);
          this.show = false;
        })
        .catch((e) => {
          let errorMessage = this.$t("pharmaops.update_failed");
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
          });
          if (e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    saveMessageTemplate(payload) {
      // If Message Template already exists, just add it.
      if (this.existing_message_template) {
        this.addMessage(payload.result, this.pu_form.instanceId);
        return;
      }
      this.useManageAttributes.updateStates({
            saving_pu_form: true,
          });
      payload = {
        payload: payload.result,
      };
      MessagesApi.create(payload, this.pu_form.instanceId)
        .then((r) => {
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
          });
          this.addMessage(r.result, this.pu_form.instanceId);
        })
        .catch((e) => {
          let errorMessage = this.$t("pharmaops.update_failed");
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
          });
          if (e.response && e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (
            e.response &&
            (e.response.status == 400 || e.response.status == 409)
          ) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    addMessage(message, instanceId) {
      let autoReplies = {};
      let key = this.formatKey(message.id);
      autoReplies[key] = {
        actionIds: [],
        messageTemplateId: message.id,
      };

      let payload = {
        id: instanceId,
        attributes: {
          messageEngine: "pinpoint",
          message: {
            settings: {
              default: {
                autoReplies: autoReplies,
              },
            },
          },
        },
      };

      this.useManageAttributes.updateStates({
        adding_pu_form: true,
          });
      PharmaopsApi.addMessageTemplate(this.pu_form.instanceId, payload)
        .then((response) => {
          this.useManageAttributes.updateStates({
        adding_pu_form: false,
          });
          this.$toast.success(
            "Success",
            this.$t("pharmaops.mt_added_successfully")
          );
          this.useManageAttributes.updateStates({
            showAddedMessageTemplateSuccess: true,
            addedSuccess: true,
          });
          this.resolve(message);
          this.show = false;
        })
        .catch((e) => {
          this.useManageAttributes.updateStates({
            adding_pu_form: false,
          });
        });
    },
    formatKey(key) {
      key = key.endsWith("-message") ? key.slice(0, -8) : key;
      return key.toUpperCase();
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    },
    onClear() {
      this.existing_message_template = null;
      this.cleanForm();

      this.save_or_update = this.approval_process
        ? this.$t("buttons.add")
        : this.$t("buttons.create");
      this.method = "POST";
    },
    cleanForm() {
      this.pu_form.id = null;
      this.pu_form.name = null;
      this.pu_form.description = null;
      this.pu_form.isActive = false;
      this.pu_form.message = null;
      this.pu_form.gcma = null;
    },
  },
};
</script>
